type UserTimingCategories = 'Assigning tables';

interface UserTimingConfig {
  /**
   * Used to combine related user timing events in to logical groups
   */
  category: UserTimingCategories;
  /**
   * Identifies the timing that is being recorded
   */
  eventName: string;
}

export const DRAG_ASSIGNMENT_TIMING: UserTimingConfig = {
  category: 'Assigning tables',
  eventName: 'Complete drag assignment in timeline',
};

export const CLICK_ASSIGNMENT_TIMING: UserTimingConfig = {
  category: 'Assigning tables',
  eventName: 'Complete assignment in timeline',
};
